import{a as o}from"./chunk.DWL5QFAQ.js";import{a as t}from"./chunk.2AIXLGYE.js";import{a as e}from"./chunk.NFEB7TIJ.js";import{css as r}from"lit";var d=r`
  ${t}
  ${o}

  :host {
    display: block;
  }

  .text-field {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    height: var(--he-form-control-height);
    font-family: var(--he-form-control-font-family);
    font-size: var(--he-form-control-font-size);
    line-height: var(--he-line-height-normal);
    vertical-align: middle;
    background-color: var(--he-color-neutral-0);
    border-radius: var(--he-form-control-border-radius);
    border: solid var(--he-form-control-border-width) var(--he-form-control-border-color);
    overflow: hidden;
    cursor: text;
  }

  .text-field--focused:not(.text-field--disabled) {
    border-color: var(--he-form-control-focus-ring-color);
    outline: solid var(--he-form-control-border-width) var(--he-form-control-focus-ring-color);
    outline-offset: -2px;
  }

  .text-field--disabled {
    opacity: var(--he-form-control-disabled-opacity);
    cursor: not-allowed;
  }

  .text-field--disabled .text-field__control::placeholder {
    color: var(--he-form-control-placeholder-color);
  }

  .text-field__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    color: var(--he-form-control-color);
    border: none;
    background: none;
    box-shadow: none;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
    height: calc(var(--he-form-control-height) - var(--he-form-control-border-width) * 2);
    padding: 0 var(--he-spacing-x-small);
  }

  .text-field__control::-webkit-search-decoration,
  .text-field__control::-webkit-search-cancel-button,
  .text-field__control::-webkit-search-results-button,
  .text-field__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .text-field__control:-webkit-autofill,
  .text-field__control:-webkit-autofill:hover,
  .text-field__control:-webkit-autofill:focus,
  .text-field__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--he-form-control-height) var(--he-color-neutral-0) inset !important;
    -webkit-text-fill-color: var(--he-color-primary-500);
    caret-color: var(--he-input-color);
  }

  .text-field__control::placeholder {
    color: var(--he-form-control-placeholder-color);
    user-select: none;
  }

  .text-field__control:focus {
    outline: none;
  }

  .text-field__start,
  .text-field__end {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .text-field__start,
  .text-field__end {
    padding: 0 var(--he-spacing-x-small);
  }

  .text-field:not(.text-field--has-start-icon) .text-field__start,
  .text-field:not(.text-field--has-end-icon) .text-field__end {
    border: solid 1px var(--he-color-neutral-100);
    background: var(--he-color-neutral-100);
  }

  .text-field--has-start-icon .text-field__start {
    padding-inline-end: 0;
  }

  .text-field--has-end-icon .text-field__end {
    padding-inline-start: 0;
  }

  .text-field:not(.text-field--has-start) .text-field__start,
  .text-field:not(.text-field--has-end) .text-field__end {
    display: none;
  }

  .text-field__start ::slotted(.he-icon),
  .text-field__end ::slotted(.he-icon) {
    color: var(--he-form-control-color);
  }

  /*
   * Input Buttons
   */
  .text-field__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--he-form-control-color);
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
    width: calc(1em + var(--he-spacing-x-small) * 2);
  }

  .text-field__button:hover {
    color: var(--he-form-control-color);
  }

  .text-field__button:focus {
    outline: none;
  }

  .text-field--empty .text-field__clear {
    visibility: hidden;
  }

  .text-field__clear-icon {
    font-size: var(--he-font-size-medium);
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide Firefox's clear button on date and time inputs */
  .text-field--is-firefox input[type='date'],
  .text-field--is-firefox input[type='time'] {
    clip-path: inset(0 2em 0 0);
  }

  /* Hide the built-in number spinner */
  .text-field--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .text-field--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .text-field--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }

  .form-control--has-interaction.form-control--has-error .text-field {
    border-color: var(--he-form-control-error-color) !important;
    outline-color: var(--he-form-control-error-color) !important;
  }

  /* High contrast */
  @media screen and (forced-colors: active) {
    .text-field--disabled {
      opacity: 1;
      border-color: ${e.GrayText};
    }

    .text-field--disabled .text-field__control {
      color: ${e.GrayText};
    }

    .text-field__control::placeholder,
    .text-field--disabled .text-field__control::placeholder {
      color: ${e.GrayText};
    }

    /* TODO: high contrast error state */
  }
`;export{d as a};
